/**  Session Storage key */
export const TRIGGER_DRAWER_KEY = 'trigger_drawer';
